import { render, staticRenderFns } from "./NoticeMessage.vue?vue&type=template&id=538b8c4f&scoped=true"
import script from "./NoticeMessage.vue?vue&type=script&lang=js"
export * from "./NoticeMessage.vue?vue&type=script&lang=js"
import style0 from "./NoticeMessage.vue?vue&type=style&index=0&id=538b8c4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b8c4f",
  null
  
)

export default component.exports